export var CustomListKey;
(function (CustomListKey) {
    CustomListKey["ClientStatus"] = "ClientStatus";
    CustomListKey["HomeCareLeadStatus"] = "HomeCareLeadStatus";
    CustomListKey["ReferralSourceTier"] = "ReferralSourceTier";
})(CustomListKey || (CustomListKey = {}));
export const REFERRAL_TIER_UNSET = "unset";
//# sourceMappingURL=custom-list.js.map